
import { computed, ComputedRef, defineComponent, ref, Ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { convertCurrency } from '@/services/ConvertCurrency';
import { formatValue } from '@/services/FormatValue'
import { PortfolioItem } from '@/store/modules/auth/models/UserAccount'
import Asset from '@/store/modules/assets/models/Asset'

import { IonBackButton, IonButtons, IonToolbar, IonHeader, IonTitle, IonContent, IonPage } from '@ionic/vue'
import useCurrency from '@/hooks/useCurrency'
import usePrivacyMode from '@/hooks/usePrivacyMode'

export default defineComponent({
    name: 'AssetHistory',
    components: { IonBackButton, IonButtons, IonToolbar, IonHeader, IonTitle, IonContent, IonPage },
    setup() {
        const store = useStore()
        const route = useRoute()
        const { preferredCurrency, currencyRate, baseCurrencyRate } = useCurrency()
        const portfolio: ComputedRef<PortfolioItem[]> = computed(() => store.getters.user.account.portfolio)
        const asset: Ref<Asset> = ref(store.getters.asset(route.params.symbol))
        const portfolioAsset = computed(() => portfolio.value.find(portfolioItem => portfolioItem.symbol == asset.value.symbol))

        const { PRIVACY_MASK, isPrivacyModeActive } = usePrivacyMode()

        return { preferredCurrency, baseCurrencyRate, currencyRate, asset, portfolioAsset, convertCurrency, formatValue, PRIVACY_MASK, isPrivacyModeActive }
    },
})
